module.exports = __webpack_public_path__ + "img/img-d21a97.png";